import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { GuideFormPopup } from './GuideFormPopup';
export const GuideDownload = () => {
  const [showPopup, setShowPopup] = useState(false);
  const guideTopics = ['Dubai property buying process', 'Expected ROI by area', 'Golden Visa eligibility', 'Tax advantages', 'Best investment zones', 'Payment plans'];
  return <section id="guide" className="bg-gray-50 py-16 md:py-24 relative overflow-hidden" data-id="element-248">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#d8a34d] opacity-[0.03] rounded-full blur-3xl pointer-events-none translate-x-1/3 -translate-y-1/3" data-id="element-249"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#d8a34d] opacity-[0.03] rounded-full blur-3xl pointer-events-none -translate-x-1/3 translate-y-1/3" data-id="element-250"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-251">
        <div className="max-w-5xl mx-auto" data-id="element-252">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-253">
            {/* Left Side: Book Mockup */}
            <div className="w-full lg:w-1/2" data-id="element-254">
              <div className="relative w-full max-w-sm mx-auto lg:mx-0 perspective-1000" data-id="element-255">
                <div className="relative w-full aspect-[3/4] rounded-r-xl rounded-l-sm bg-gradient-to-br from-[#1a2e1c] to-[#0f1f10] border border-[#d8a34d]/30 shadow-[20px_20px_40px_rgba(26,46,28,0.4),-5px_0_15px_rgba(216,163,77,0.1)] transform rotate-y-[-15deg] rotate-x-[5deg] transition-transform duration-500 hover:rotate-y-0 hover:rotate-x-0 group" data-id="element-256">
                  {/* Book Spine */}
                  <div className="absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-[#0f1f10] to-[#1a2e1c] rounded-l-sm border-r border-[#d8a34d]/20" data-id="element-257"></div>

                  {/* Book Cover Content */}
                  <div className="absolute inset-0 ml-4 p-6 md:p-8 flex flex-col justify-between" data-id="element-258">
                    <div data-id="element-259">
                      <div className="w-12 h-1 bg-[#d8a34d] mb-6" data-id="element-260"></div>
                      <h3 className="text-2xl md:text-3xl font-display font-bold text-white leading-snug" data-id="element-261">
                        Dubai Property
                        <br data-id="element-262" />
                        Investment Guide
                        <br data-id="element-263" />
                        <span className="text-[#d8a34d]" data-id="element-264">2026</span>
                      </h3>
                    </div>
                    <div data-id="element-265">
                      <p className="text-[#d8a34d] text-sm tracking-widest uppercase mb-2" data-id="element-266">
                        For Indian Investors
                      </p>
                      <div className="w-full h-px bg-[#d8a34d]/30" data-id="element-267"></div>
                    </div>
                  </div>

                  {/* Subtle reflection */}
                  <div className="absolute inset-0 ml-4 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-268"></div>
                </div>
              </div>
            </div>

            {/* Right Side: Copy & CTA */}
            <div className="w-full lg:w-1/2" data-id="element-269">
              <h2 className="text-3xl md:text-4xl font-display font-bold text-[#1a1a1a] leading-tight mb-8" data-id="element-270">
                Dubai Property Investment Guide for Indian Investors{' '}
                <span className="text-[#d8a34d]" data-id="element-271">(2026)</span>
              </h2>

              {/* Checklist */}
              <div className="space-y-3.5 mb-10" data-id="element-272">
                {guideTopics.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-273">
                    <CheckCircle2 className="w-4.5 h-4.5 text-[#d8a34d] flex-shrink-0" data-id="element-274" />
                    <span className="text-gray-600 text-sm md:text-base font-medium" data-id="element-275">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* CTA */}
              <button onClick={() => setShowPopup(true)} className="btn-gold px-8 py-4 md:px-10 md:py-5 rounded-lg font-bold text-lg inline-block shadow-xl" data-id="element-276">
                Download Free Investor Guide
              </button>
            </div>
          </div>
        </div>
      </div>

      <GuideFormPopup isOpen={showPopup} onClose={() => setShowPopup(false)} data-id="element-277" />
    </section>;
};